import React from "react";

const SvgWarning = props => (
  <svg viewBox="0 0 215.46 209" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h215.46v209H0z" />
        <path d="M108.35 7a98.26 98.26 0 1098.26 98.26A98.26 98.26 0 00108.35 7zm0 9.25a89 89 0 11-89 89 89 89 0 0189-89.02z" />
        <path d="M100.89 110.11l-2.17-32.46q-.61-9.5-.61-13.62 0-5.62 3-8.78a10.12 10.12 0 017.76-3.15q5.82 0 7.79 4t2 11.62a87.74 87.74 0 01-.47 9.09l-2.91 33.41a26.31 26.31 0 01-2 9.15 5.32 5.32 0 01-5.15 3.18 5.13 5.13 0 01-5.08-3.08 30.54 30.54 0 01-2.16-9.36zm7.52 44.6a10.65 10.65 0 01-7.22-2.68 9.4 9.4 0 01-3.08-7.49 10.07 10.07 0 0110.16-10.1 10.07 10.07 0 017.29 2.95 9.63 9.63 0 013 7.15 9.48 9.48 0 01-3 7.46 10.43 10.43 0 01-7.15 2.71z" />
      </g>
    </g>
  </svg>
);

export default SvgWarning;
